import { IMAGES } from "../../data/site";

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="overflow-hidden">
      <div className="mx-auto grid max-w-7xl grid-cols-1 md:grid-cols-2">
        <div className="flex flex-col justify-center px-4 py-16 md:px-12 md:py-24">
          <p className="font-script text-2xl text-[#E63946] md:text-3xl">
            İyi burger,
          </p>
          <h1 className="mt-2 text-5xl font-black uppercase leading-[0.95] tracking-tighter text-[#1A1A1A] sm:text-6xl lg:text-7xl">
            Gerçek
            <br />
            Lezzet<span className="text-[#E63946]">.</span>
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-6 max-w-md text-base font-medium text-[#4A4A4A] md:text-lg"
          >
            %100 dana eti, günlük taze malzemeler ve efsane patates. Menümüz
            kısa, lezzetimiz net: hamburger ve patates kızartması.
          </p>
          <ul
            data-testid="hero-badges"
            className="mt-10 flex flex-wrap gap-x-6 gap-y-2 text-sm font-bold uppercase tracking-wide text-[#1A1A1A]"
          >
            <li className="flex items-center gap-2">
              <span className="h-2 w-2 bg-[#E63946]" /> %100 Dana Eti
            </li>
            <li className="flex items-center gap-2">
              <span className="h-2 w-2 bg-[#E63946]" /> Günlük Taze
            </li>
            <li className="flex items-center gap-2">
              <span className="h-2 w-2 bg-[#E63946]" /> Paket Servis
            </li>
          </ul>
        </div>
        <div className="border-t-2 border-[#1A1A1A] md:border-l-2 md:border-t-0">
          <img
            data-testid="hero-image"
            src={IMAGES.hero}
            alt="Deny's çift katlı cheeseburger, patates kızartması ve Pepsi"
            className="h-full max-h-[80vh] w-full object-cover object-top md:max-h-none"
          />
        </div>
      </div>
    </section>
  );
};
